import {IModel} from "../../model/B2CInfo";
import CarsSectionHeader from "./CarsSectionHeader";
import './CarsItem.css'
import CarCard from "../../carcard/CarCard";
import React from "react";

export interface ICarSection {
    title: string
    subtitle: string
    color: string
    cars: Array<string>
}

interface ICarSectionProps {
    section: ICarSection
    models: Map<string, IModel>
    mobile: boolean
}

export default function CarsSection(props: ICarSectionProps) {
    let models = props.section.cars.map((car) => {
        let model = props.models.get(car)!;
        return <CarCard mobile={props.mobile} model={model} withShadow={true}/>
    });
    return <div className={`${props.mobile ? "Cars_container_content_mobile" : "Cars_container_content"}`}>
        <CarsSectionHeader color={props.section.color} mobile={true} title={props.section.title} subtitle={props.section.subtitle}/>
        <div className={`${props.mobile ? "Cars_section_models_mobile" : "Cars_section_models"}`}>{models}</div>
    </div>
}